import React, { useState } from 'react';
import { Instagram, Check } from 'lucide-react';
import { useStore, hasFollowedInstagram, INSTAGRAM_URL, INSTAGRAM_FOLLOW_POINTS } from '../lib/store';
interface InstagramFollowProps {
  /**
   * 'light' (default) for the white consumer surfaces; 'dark' for placing the
   * card on a brand-blue panel (e.g. the registration "done" screen).
   */
  variant?: 'light' | 'dark';
  className?: string;
}
/**
 * Follow-us-on-Instagram card, woven across the consumer journey so people can
 * keep in touch and hear about new drops. Following awards a one-time
 * +10-point reward (claimed the first time the user taps through to Instagram).
 */
export function InstagramFollow({
  variant = 'light',
  className = ''
}: InstagramFollowProps) {
  const {
    user,
    followInstagram
  } = useStore();
  const alreadyFollowed = hasFollowedInstagram(user);
  // Local mirror so the card flips to the "claimed" state immediately on tap.
  const [claimed, setClaimed] = useState(alreadyFollowed);
  const followed = alreadyFollowed || claimed;
  const handleFollow = () => {
    // Open Instagram in a new tab, then award the one-time reward.
    window.open(INSTAGRAM_URL, '_blank', 'noopener,noreferrer');
    if (!followed) {
      followInstagram();
      setClaimed(true);
    }
  };
  const dark = variant === 'dark';
  return <section aria-label="Follow Gone Fishing on Instagram" className={`rounded-2xl p-5 ${dark ? 'bg-white/10 border border-white/15' : 'bg-white shadow-sm border-2 border-brand-blue/10'} ${className}`} data-id="element-385" data-mp="3r8bdtbx7k7ta">
      <div className="flex items-center space-x-3 mb-3" data-id="element-386" data-mp="3hh6ww6nz2cvt">
        <div className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0" style={{
        background: 'linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)'
      }} data-id="element-387" data-mp="3cl8eczpbrp3b">
          <Instagram className="w-6 h-6 text-white" data-id="element-388" data-mp="33ipg6swhi0ne" />
        </div>
        <div className="min-w-0" data-id="element-389" data-mp="2ylgtqg4azagc">
          <h3 className={`font-bold leading-tight ${dark ? 'text-white' : 'text-gray-900'}`} data-id="element-390" data-mp="2ymighhuolldw">
            Follow us for new drops
          </h3>
          <p className={`text-sm ${dark ? 'text-brand-light/80' : 'text-gray-500'}`} data-id="element-391" data-mp="2sz6j1nm84ui7">
            @gonefishing.app
          </p>
        </div>
        {!followed && <span className={`ml-auto shrink-0 text-xs font-bold px-2.5 py-1 rounded-full ${dark ? 'bg-brand-yellow text-brand-navy' : 'bg-brand-yellow/20 text-brand-blue'}`} data-id="element-392" data-mp="2jyrvsipp95c2">
            +{INSTAGRAM_FOLLOW_POINTS} pts
          </span>}
      </div>

      {followed ? <div className={`flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold ${dark ? 'bg-green-400/15 text-green-300' : 'bg-green-50 text-green-700'}`} data-id="element-393" data-mp="2xwgi7uzf0kj8">
          <Check className="w-4 h-4" data-id="element-394" data-mp="3ql47e1nabu22" />
          Following — +{INSTAGRAM_FOLLOW_POINTS} points earned
        </div> : <button type="button" onClick={handleFollow} className="w-full flex items-center justify-center gap-2 rounded-xl py-3 text-sm font-bold text-white transition-opacity hover:opacity-90 active:opacity-80" style={{
      background: 'linear-gradient(45deg,#F58529,#DD2A7B,#8134AF,#515BD4)'
    }} data-id="element-395" data-mp="3veglviy92kh3">
          <Instagram className="w-4 h-4" data-id="element-396" data-mp="1opod2hw3207i" />
          Follow on Instagram
        </button>}
    </section>;
}